import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getCategoryHeirarchy } from '../../redux/getCategoryHeirarchy';
import AddProductForm from '../../component/productsComps/AddProductForm';
import InformationHeader from '../../component/reusable/informationHeader/InformationHeader';
import { exportManufacturerThunk } from '../../redux/manufacturer/getAllManufacturerSlice';
import { getAttributesAddProdThunk, getProductThunk } from '../../redux/productSlice';

const AddProduct = () => {

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getCategoryHeirarchy());
    dispatch(exportManufacturerThunk())
    dispatch(getAttributesAddProdThunk())
    dispatch(getProductThunk())
  }, []);

  return (
    <div >
      <InformationHeader
        mainpage="Dashboard"
        prevpage="Product"
        pagename="Add Product"
        buttonText="Save"
      />
      <AddProductForm
        from={'add'} productDetails={null}
        loadings={false}
      />
    </div>
  );

};

export default AddProduct;
